import { render, staticRenderFns } from "./InvocationScrollList.vue?vue&type=template&id=73b9fa1c&scoped=true"
import script from "./InvocationScrollList.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvocationScrollList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvocationScrollList.vue?vue&type=style&index=0&id=73b9fa1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9fa1c",
  null
  
)

export default component.exports